module.exports = __webpack_public_path__ + "img/pro-5-gen-landscape-mask.a97f902.png";